module.exports = __webpack_public_path__ + "static/media/sc_37_i.47cae361.png";